<template>
    <div class="content">
        <div class="content-view">
            <div class="content-head">线下回款申报</div>
            <div class="descriptions">
                <el-descriptions title="" :column="1" size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="ERP订单号">
                        <template slot="label">
                            <span class="required">*</span>
                            ERP订单号
                        </template>
                        <el-input autocomplete="on" name="ERP_Code"  v-model="params.ERP_Code" placeholder="" clearable style="max-width: 400px"></el-input>
                        <el-button type="primary" style="margin-left: 10px" @click="getSearch_ERPCode()" :loading="loading">查询</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户号">
                        <template slot="label">
                            <span class="required">*</span>
                            客户号
                        </template>
                        <!-- <el-input v-model="params.CUSTOMER_NO" placeholder="" disabled clearable style="width: 400px"></el-input> -->
                        <span>{{ params.customer_no }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户名称">
                        <template slot="label">
                            <span class="required">*</span>
                            客户名称
                        </template>
                        <span>{{ params.customer_name }}</span>
                        <!-- <el-input v-model="params.Customer_name" placeholder="" disabled  clearable style="width: 400px"></el-input> -->
                    </el-descriptions-item>
                    <el-descriptions-item label="订单总额">
                        <template slot="label">
                            <span class="required">*</span>
                            订单总额
                        </template>
                        <span>
                            <span v-if=" params.customer_amount " >
                                ¥
                            </span>
                            {{ params.customer_amount }} </span>
                        <!-- <el-input v-model="params.Payment_Amount" placeholder="" disabled  clearable style="width: 400px"></el-input> -->
                    </el-descriptions-item>
                    <el-descriptions-item label="可分款总金额">
                        <template slot="label">
                            <span class="required">*</span>
                            可分款总金额
                        </template>
                        <span v-if="params.customer_amount">{{ params.customer_amount - params.payment_amount | formatePrice}} </span>
                        <!-- <el-input v-model="params.Payment_Amount" placeholder="" disabled  clearable style="width: 400px"></el-input> -->
                    </el-descriptions-item>
                    <el-descriptions-item label="汇入银行">
                        <template slot="label">
                            <span class="required">*</span>
                            汇入银行
                        </template>
                        <el-input v-model="params.Receipt_BankName" placeholder="" disabled clearable style="max-width: 400px"></el-input>
                        <el-button type="primary" style="margin-left: 10px" @click="chooseVoucher">选择凭证</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="付款凭证类型">
                        <template slot="label">
                            <span class="required">*</span>
                            付款凭证类型
                        </template>

                        <el-input v-model="params.Receipt_Type" placeholder="" disabled style="max-width: 400px"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="汇款单位">
                        <template slot="label">
                            <span class="required">*</span>
                            汇款单位
                        </template>
                        <el-input v-model="params.Receipt_Code" placeholder="" disabled style="max-width: 400px"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="付款日期">
                        <template slot="label">
                            <span class="required">*</span>
                            付款日期
                        </template>
                        <el-input v-model="params.Receipt_PayDate" placeholder="" disabled style="max-width: 400px"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="汇款金额">
                        <template slot="label">
                            <span class="required">*</span>
                            汇款金额
                        </template>
                        <el-input v-model="params.Receipt_Amount" placeholder="" disabled style="max-width: 200px"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="凭证剩余金额">
                        <template slot="label">
                            <span class="required">*</span>
                            凭证剩余金额
                        </template>
                        <span>
                            {{ params.Last_Amount | formatePrice}}
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="分款金额">
                        <template slot="label">
                            <span class="required">*</span>
                            分款金额
                        </template>
                        <el-input autocomplete="on" name="distribute_Amount"  v-model="params.distribute_Amount" placeholder="" style="max-width: 200px"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="付款不一致说明">
                        <div style="width: 300px">
                            <Hwupload ref="Hwupload" @onSuccess="onSuccessUpload" />
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
                <div style="text-align: center">
                    <el-button>取消</el-button>
                    <el-button type="primary" @click="confirmSave">保存</el-button>
                </div>
            </div>
        </div>
        <el-dialog title="查找到如下订单信息" :visible.sync="dialogVisible" width="800px" :before-close="dialogBeforeClose" :close-on-click-modal="false">
            <div>
                <el-row :gutter="10">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户号：</div>
                            <el-input v-model="result.CUSTOMER_NO" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户名称：</div>
                            <el-input v-model="result.Customer_name" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">工程名称：</div>
                            <el-input v-model="result.PROJECT_NAME" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">分支机构：</div>
                            <el-input v-model="result.REGION_CODE" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">合同额：</div>
                            <el-input v-model="result.Gross_Amount" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">签订人：</div>
                            <el-input v-model="result.Sales_name" placeholder="" clearable class="el-select-max"></el-input>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button @click="dialogBeforeClose()">取 消</el-button>
                <el-button type="primary" @click="onSave()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="repeatShow" width="800px" :before-close="repeatShowClose" :close-on-click-modal="false">
            <div class="content-head mb10">已存在以下凭证，是否继续增加：</div>
            <div class="mb20" v-for="(item, index) in equalReceiptList" :key="index">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款日期：</div>
                            <div>{{ elformatDate(item.Receipt_PayDate) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇入银行：</div>
                            <div>{{ item.Receipt_BankName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇款单位：</div>
                            <div>{{ item.Receipt_Code }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">附件：</div>
                            <el-link type="primary" @click="downLoadFile(item.Payment_Receipt_File)">下载</el-link>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇款金额：</div>
                            <div>￥{{ item.Receipt_Amount || 0 }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button @click="repeatShowClose()">取 消</el-button>
                <el-button type="primary" @click="branchdistribute()">确 定</el-button>
            </div>
        </el-dialog>
        <PaymentReceipt :isSwitch="isSwitch" v-if="isSwitch" @setSwitchClose="setSwitchClose" />
    </div>
</template>
<script>
import PaymentReceipt from '@/components/PaymentReceipt/index.vue';
import Hwupload from '@/components/Hwupload/index.vue';
export default {
    components: {
        PaymentReceipt,
        Hwupload
    },
    data() {
        return {
            loading: false,
            isSwitch: false,
            receiptList: [], // 凭证列表
            receiptAmount: '',
            receiptID: '',
            dialogVisible: false,
            params: {
                ERP_Code: '',
                customer_no: '',
                customer_name: '',
                customer_amount: '',
                payment_amount: 0,
                project_name: '',
                region_code: '',
                sale_man: '',
                Receipt_BankName: '',

                repect_ID: '',
                Receipt_Type: '',
                Receipt_Code: '',
                Receipt_PayDate: '',
                Receipt_Amount: '',
                Last_Amount: 0,
                distribute_Amount: '',
                Receipt_File: '',
                Payment_Receipt_File: ''
            },
            result: {},
            fileList: [],
            equalReceiptList: [], // 凭证列表
            repeatShow: false
        };
    },
    watch: {
        'params.Receipt_Amount': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && newVal !== undefined && newVal !== null) {
                    this.format_input_num({ value: newVal });
                }
            },
            immediate: false
        },
        'params.distribute_Amount': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && newVal !== undefined && newVal !== null) {
                   this.params.distribute_Amount = this.format_input_num({ value: newVal });
                }
            },
            immediate: false
        }
    },
    mounted() {},
    methods: {
        /*
        查询订单信息
        */
        getSearch_ERPCode() {
            this.loading = true;
            this.$newsApi
                .getSearch_ERPCode({ ERP_Code: this.params.ERP_Code })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.result = res.data.data;
                        this.dialogVisible = true;
                    }
                })
                .finally(() => (this.loading = false));
        },
        format_input_num(obj) { 
            // 添加空值检查，避免 undefined 或 null 错误
            if (!obj || obj === undefined || obj.value === null) {
                return;
            }
            
            // 清除"数字"和"."以外的字符 
            obj.value = obj.value.replace(/[^\d.]/g,""); 
            // 验证第一个字符是数字 
            obj.value = obj.value.replace(/^\./g,""); 
            // 只保留第一个, 清除多余的 
            obj.value = obj.value.replace(/\.{2,}/g,"."); 
            obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
            // 只能输入两个小数 
            obj.value = obj.value.replace(/^(-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); 
            return obj.value;

        },
        dialogBeforeClose() {
            this.dialogVisible = false;
        },
        onSave() {
            this.dialogVisible = false;

            // 映射关系
            const mapping = {
                customer_no: 'CUSTOMER_NO',
                customer_name: 'Customer_name',
                customer_amount: 'ORDER_AMOUNT',
                project_name: 'PROJECT_NAME',
                region_code: 'REGION_CODE',
                sale_man: 'Sales_name',
                payment_amount: 'Payment_Amount',
            };
            // 赋值操作
            for (const key in mapping) {
                if (mapping.hasOwnProperty(key)) {
                    this.params[key] = this.result[mapping[key]];
                }
            }
            console.log(this.params, 99999);
        },
        async setSwitchClose(e, data) {
            this.isSwitch = false;
            if (e) {
                let json = JSON.stringify(data);
                let result = await this.$newsApi.order.ShowOrdersPaymentReceipt({
                    Json: json
                });
                console.log(result);
                let res = result.data.data;
                if (res && res.list && res.list.length > 0) {
                    this.params.Receipt_Type = res.list[0].Receipt_Type;
                    this.params.Receipt_BankName = res.list[0].Receipt_BankName;
                    this.params.Receipt_Code = res.list[0].Receipt_Code;
                    this.params.repect_ID = res.list[0].Receipt_ID;
                    this.params.Receipt_PayDate = res.list[0].Receipt_PayDate;
                    this.params.Receipt_Amount = res.list[0].Receipt_Amount;
                    this.params.Last_Amount = res.list[0].Last_Amount;
                    this.params.Receipt_File = res.list[0].Payment_Receipt_File;
                    this.params.distribute_Amount = res.Receipt_Amount.split(',')[0].split('|')[1];
                }
            }
        },
        chooseVoucher() {
            this.isSwitch = true;
        },
        // 新增：凭证选择回调
        onReceiptSelected(receiptData) {
            this.receiptList = receiptData.list;
            this.receiptAmount = receiptData.Receipt_Amount;
            this.params.Last_Amount = receiptData.Last_Amount;
            this.receiptID = receiptData.Receipt_ID;
        },
        removeReceipt(index) {
            this.receiptList.splice(index, 1);
        },
        onSuccessUpload(e) {
            this.params.Payment_Receipt_File = e;
        },
        // 保存
        async confirmSave() {
            let json = JSON.stringify(this.params);
            if (!this.params.ERP_Code) {
                this.$message.error('请先查询ERP订单号');
                return;
            }
            let loadingInstance = this.$loading(); // 显示 loading
            let res = await this.$newsApi.getCheckOrdersPaymentReceiptDistribute({
                Json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (res.data.Resultcode == 0 && res.data.Resultinfo == 'true') {
                this.branchdistribute();
            } else if (res.data.Resultcode == 0 && res.data.Resultinfo == '') {
                this.equalReceiptList = res.data.data;
                this.repeatShow = true;
            }
        },
        // 确认
        branchdistribute() {
            let json = JSON.stringify(this.params);
            let loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi
                .getbranch_distribute({ Json: json })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.$alert('操作成功！', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                })
                .finally(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                });
        },
        repeatShowClose() {
            this.repeatShow = false;
        },
        downLoadFile(filePath) {
            if (filePath) {
                window.open(this.$appUrl + filePath);
            } else {
                this.$message.error('文件路径不存在');
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.custom-label {
    // background: #f5f7fa !important;
    max-width: 150px !important;
    min-width: 120px !important;
    line-height: 30px;
    display: inline-block;
    text-align: right !important;
    font-weight: bold;
}
/deep/.el-form-item__label {
    font-weight: 500 !important;
}

.el-radio {
    margin-right: 10px !important;
}
.Tips {
    width: 16px;
    height: 16px;
    vertical-align: top;
    margin-right: 10px;
}
.content-view {
    height: 100%;
    background: #fff;
    padding: 0px 20px 20px 20px;
}
.content-head {
    line-height: 50px;
    padding-bottom: 0px;
    padding: 0px !important;
}
.descriptions {
    padding: 0px 20px;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 120px;
    }
}
.red {
    color: #f56c6c;
    margin-right: 10px;
    font-weight: 700;
}
/deep/.el-descriptions-item__container{
    align-items: center;
}
</style>
